import React from 'react';
import { MapPinIcon, PhoneIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { useLanguage } from '../contexts/LanguageContext';
import { business } from '../data/business';
import { gallery } from '../data/gallery';
import { ui } from '../data/ui';
export function WorkGallery() {
  const {
    t
  } = useLanguage();
  const g = ui.gallery;
  return <section id="gallery" className="section-y bg-mist" aria-labelledby="gallery-title" data-id="element-369" data-mp="8g3fj5dz7b2b">
      <div className="container-page" data-id="element-370" data-mp="dewvr5kndg66">
        <SectionHeading id="gallery-title" title={t(g.title)} subtitle={t(g.subtitle)} data-id="element-371" data-mp="ddvbqblnljcb" />

        <ul className="mx-auto mt-12 grid max-w-6xl gap-6 md:grid-cols-2 xl:grid-cols-3" data-id="element-372" data-mp="i5dcoznofjxa">
          {gallery.map(item => <li key={item.title.en} data-id="element-373" data-mp="n46lwfvxkorn">
              <article className="flex h-full flex-col overflow-hidden rounded-xl bg-white shadow-[0_2px_8px_rgba(0,0,0,0.08)] ring-1 ring-line" data-id="element-374" data-mp="r6bj1oll83j1">
                <div className="relative aspect-[4/3] bg-line" data-id="element-375" data-mp="w6695pxjgp31">
                  <img src={item.image} alt={t(item.alt)} loading="lazy" decoding="async" className="h-full w-full object-cover object-center" data-id="element-376" data-mp="v5gdbxup4tts" />
                  <span className={`absolute left-3 top-3 rounded-md px-2.5 py-1 text-xs font-bold text-white ${item.type === 'interior' ? 'bg-navy' : 'bg-ember-strong'}`} data-id="element-377" data-mp="r1s83ltjeabp">
                    {t(g[item.type])}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-5" data-id="element-378" data-mp="19tutfah4iesa">
                  <h3 className="font-display text-base font-bold leading-snug text-ink md:text-lg" data-id="element-379" data-mp="19ucssfz3194f">{t(item.title)}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-380" data-mp="150ru0lpo0b46">{t(item.description)}</p>
                  <p className="mt-auto flex items-center gap-1.5 pt-4 text-xs text-muted" data-id="element-381" data-mp="101xatinsckjj">
                    <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-382" data-mp="1xli9excuk5fs" />
                    {item.location}
                  </p>
                </div>
              </article>
            </li>)}
        </ul>

        <p className="mt-10 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-center text-body" data-id="element-383" data-mp="3r24rdf9d3zl0">
          {t(g.more)} {t(g.callUs)}
          <a href={business.phoneHref} className="inline-flex items-center gap-1.5 font-semibold text-navy hover:underline" data-id="element-384" data-mp="3d9yblua4fum3">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-385" data-mp="3i7zry7g5xftv" />
            {business.phoneDisplay}
          </a>
        </p>
      </div>
    </section>;
}